import { useState } from 'react';

import { getPlayPlayersLimitInfo } from '../services/play/playService';

export const usePlayPlayersLimit = (baseUrl?: string) => {
  const [loading, setLoading] = useState(false);

  const getLimitInfo = (teamId: string) => {
    setLoading(true);

    return getPlayPlayersLimitInfo({ teamId, baseUrl }).finally(() => {
      setLoading(false);
    });
  };

  return {
    loading,
    getLimitInfo,
  };
};
